import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Form, FormInstance } from 'antd';
import { FormItemName } from '../../../../lib/models/Form';
import { CoverageTypeT } from '../../../../lib/types/product';
import styles from '../RegionCard/index.module.scss';
import { FormItemTitle } from '../FormItemTitle';
import { FormItem } from '../../../../components/FormItem';
import { AppSegmented } from '../../../../components/AppSegmented';
import { FormCardButton } from '../../../designSettings/components/FormCardButton';
import { DistrictRow } from '../DistrictRow';

const district = 'pages.products.productConfigurator.formItems.district';
const coverageType = 'pages.products.productConfigurator.formItems.coverageType';

type Props = {
  form: FormInstance;
};

export const DistrictCard: FC<Props> = ({ form }) => {
  const { t } = useTranslation();

  const rulesLength = Form.useWatch([FormItemName.DISTRICT], form)?.length;

  const options = [
    {
      label: t(`${coverageType}.include`),
      value: CoverageTypeT.INCLUDE,
    },
    {
      label: t(`${coverageType}.exclude`),
      value: CoverageTypeT.EXCLUDE,
    },
  ];

  return (
    <Card className={styles.root}>
      <div className={styles.header}>
        <FormItemTitle>{t(`${district}.title`)}</FormItemTitle>
        <FormItem
          hasFeedback
          name={[FormItemName.DISTRICT, FormItemName.DISTRICT_COVERAGE]}
          className={styles.radioGroup}
          initialValue={CoverageTypeT.INCLUDE}
        >
          <AppSegmented options={options} />
        </FormItem>
      </div>

      <div className={styles.list}>
        <Form.List name={[FormItemName.DISTRICT, FormItemName.DISTRICTS]}>
          {(fields, { add, remove }) => (
            <>
              {fields.map((field) => (
                <DistrictRow key={field.key} name={field.name} remove={remove} />
              ))}
              <FormCardButton disabled={rulesLength >= 10} onClick={() => add()}>
                + {t(`${district}.addDistrict`)}
              </FormCardButton>
            </>
          )}
        </Form.List>
      </div>
    </Card>
  );
};
